/* projects/shared/components/skip-link/skip-link.component.scss */
skip-link .skip-link {
  position: absolute;
  top: -1000px;
  left: -1000px;
  z-index: 1000;
  transform: translateX(-100%);
  transition: transform 0.3s;
  display: grid;
  grid-auto-flow: column;
  gap: var(--space-s);
}
skip-link .skip-link:focus,
skip-link .skip-link:focus-within,
skip-link .skip-link:focus-visible {
  top: 0;
  left: 0;
  transform: translateY(0);
}
/*# sourceMappingURL=skip-link.component-QGKMWL3V.css.map */
